import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, ButtonGroup, Col, Input, Row } from 'reactstrap';
import { IDispatchList } from 'src/Interfaces/DispatchInterface';
import { IUser } from 'src/Interfaces/UserInterface';
import { DispatchStore } from 'src/Stores/Dispatch/DispatchStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DispatchListTable from '../DispatchListTable/DispatchListTable';


@inject('stores')
@observer
export class Dispatches extends React.Component {
    public props: any;

    public DispatchStore: DispatchStore;
    public UserStore: UserStore;
    private MessageStore: MessageStore;
    private userDisposer: any;
    public state = {
        statusFilters: [] as any[],
        typeFilters: [] as any[],
        wellSearchDest: '',
        wellSearchSource: '',
    };
    private refreshTimeout: any;

    constructor(props: any) {
        super(props);
        this.DispatchStore = this.props.stores.DispatchStore;
        this.UserStore = this.props.stores.UserStore;
        this.MessageStore = this.props.stores.MessageStore;
    }

    public componentDidMount() {

        this.DispatchStore.getDispatches();
        this.refreshTimeout = setInterval(this.updateDispatches, 300000);
        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        } else {
            this.setPreferences(this.UserStore.user);
        }
        this.userDisposer = observe(this.UserStore, 'user', change => {
            if (change.newValue)
            {
                this.setPreferences(change.newValue);
            }
            return change;
        });
    }

    private setPreferences = (user: IUser) => {
        const preferences = this.getFiltersFromPreferences(user.preferences);
        this.setState(preferences);
    }

    private getFiltersFromPreferences = (preferences: any) => {
        const statusFilters = [
                preferences['Preferences.Dispatch.List.Status.Submitted'] === 'true' ? 'submitted' : '',
                preferences['Preferences.Dispatch.List.Status.Rejected'] === 'true' ? 'rejected' : '',
                preferences['Preferences.Dispatch.List.Status.Approved'] === 'true' ? 'approved' : '',
                preferences['Preferences.Dispatch.List.Status.Confirmed'] === 'true' ? 'confirmed' : '',
                preferences['Preferences.Dispatch.List.Status.Denied'] === 'true' ? 'denied' : '',
                preferences['Preferences.Dispatch.List.Status.Cancelled'] === 'true' ? 'cancelled' : '',
                preferences['Preferences.Dispatch.List.Status.Completed'] === 'true' ? 'completed' : '',
            ].filter(e => e !== '');
        const typeFilters = [
                preferences['Preferences.Dispatch.List.Type.Delivery'] === 'true' ? 'delivery' : '',
                preferences['Preferences.Dispatch.List.Type.Pickup'] === 'true' ? 'pickup' : '',
                preferences['Preferences.Dispatch.List.Type.Transfer'] === 'true' ? 'transfer' : '',
            ].filter(e => e !== '');

        return {
            statusFilters: statusFilters.length === 7 ? [] : statusFilters,
            typeFilters: typeFilters.length === 3 ? [] : typeFilters,
        };
    }

    public updateDispatches = () => {
        this.DispatchStore.getDispatches();
    }

    public buttonColor = (listName: string, buttonName: string) => {
        const currList: any[] = this.state[listName];
        if (currList.some(value => value === buttonName)) {
            return 'primary';
        }
        return 'outline-primary';
    }

    public allButtonTypeColor = (listName: string) => {
        if (this.state[listName].length > 0) {
            return 'outline-primary';
        }
        return 'primary';
    }

    public handleFilterBoxClick = (listName:string, filterName: string) => (event: any) => {
        const filterIndex = this.state[listName].findIndex((value: any) => value === filterName);
        let listFilters: any[] = this.state[listName];
        if (filterName === 'all') {
            listFilters = [];
        } else if (filterIndex < 0) {
            listFilters.push(filterName);
        } else {
            listFilters.splice(filterIndex, 1);
        }

        if (listName === 'statusFilters' && listFilters.length === 7) {
            listFilters = [];
        }
        if (listName === 'typeFilters' && listFilters.length === 3) {
            listFilters = [];
        }
        this.setState({[listName]: listFilters});
    }

    private mapShowApproval = (item: IDispatchList) => {
        const hasApproveAll = this.UserStore.hasPermission('Permissions.Dispatch.Approve.All');
        if (hasApproveAll) {
            return true;
        }
        const hasApproveAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Approve.Assigned');
        if (hasApproveAssigned) {
            const sourceWellIds = item.sourceWell && item.sourceWell.engineerIds ? item.sourceWell.engineerIds : [];
            const destWellIds = item.destinationWell && item.destinationWell.engineerIds ? item.destinationWell.engineerIds : [];
            return sourceWellIds.concat(destWellIds).some(id => id === this.UserStore.user.id);
        }
        return false;
    }

    private approveDispatch = (dispatchId: string) => {
        const currDispatch = this.DispatchStore.dispatches.find(d => d.id === dispatchId);
        if (currDispatch) {
            this.DispatchStore.updateDispatchStatus(dispatchId, 
                {
                    comment: '',
                    estimatedArrival: currDispatch.estimatedArrival,
                    id: '',
                    requestedArrival: currDispatch.requestedArrival,
                    status: 'Approved',
                })
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Dispatch Approved.', 'success');
                        this.DispatchStore.getDispatches();
                    }
                });
        }
    }

    private rejectDispatch = (dispatchId: string) => {
        const currDispatch = this.DispatchStore.dispatches.find(d => d.id === dispatchId);
        if (currDispatch) {
            this.DispatchStore.updateDispatchStatus(dispatchId, 
                {
                    comment: '',
                    estimatedArrival: currDispatch.estimatedArrival,
                    id: '',
                    requestedArrival: currDispatch.requestedArrival,
                    status: 'Rejected',
                })
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Dispatch Rejected.', 'success');
                        this.DispatchStore.getDispatches();
                    }
                });
        }
    }

    public handleWellSearch = (event: any) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    public filterDispatchList = (item: IDispatchList) => {
        let resultType;
        let resultStatus;
        if (this.state.typeFilters.length === 0) {
            resultType = true;
        } else {

            for (const filterName of this.state.typeFilters)
            {
                const result = item.type.toLowerCase() === filterName;

                if (result) {
                    resultType = true;
                }
            }
        }

        if (this.state.statusFilters.length === 0) {
            resultStatus = true;
        } else {
            for (const filterName of this.state.statusFilters) {

                let result;
                switch(filterName) {
                    case 'approved':
                        result = item.dispatchStatus === 'Approved';
                        break;
                    case 'submitted':
                        result = item.dispatchStatus === 'Submitted';
                        break;
                    case 'updated':
                        result = item.dispatchStatus === 'Updated';
                        break;
                    case 'confirmed':
                        result = item.dispatchStatus === 'Confirmed';
                        break;
                    case 'received':
                        result = item.dispatchStatus === 'Received';
                        break;
                    case 'rejected':
                        result = item.dispatchStatus === 'Rejected';
                        break;
                    case 'completed':
                        result = item.dispatchStatus === 'Completed';
                        break;
                    case 'denied':
                        result = item.dispatchStatus === 'Denied';
                        break;
                    case 'cancelled':
                        result = item.dispatchStatus === 'Cancelled';
                        break;
                }
                if (result) {
                    resultStatus = true;
                }
            }
        }
        let wellSearch = true;
        const { wellSearchSource, wellSearchDest } = this.state;
        if (wellSearchSource !== '') {
            if (item.sourceWell && !item.sourceWell.wellName.toLowerCase().includes(wellSearchSource.toLowerCase())) {
                wellSearch = false;
            } else if (!item.sourceWell && !item.destinationWell.warehouseName.toLowerCase().includes(wellSearchSource.toLowerCase())) {
                wellSearch = false;
            }
        }

        if (wellSearchDest !== '') {
            if (item.destinationWell && !item.destinationWell.wellName.toLowerCase().includes(wellSearchDest.toLowerCase())) {
                wellSearch = false;
            } else if (!item.destinationWell && !item.sourceWell.warehouseName.toLowerCase().includes(wellSearchDest.toLowerCase())) {
                wellSearch = false;
            }
        }

        return resultType && resultStatus && wellSearch;
    }
    
    public componentWillUnmount() {
        clearInterval(this.refreshTimeout);
        this.userDisposer();
    }

    public render() {
        if (!this.DispatchStore.dispatches || !this.UserStore.user) {
            return '';
        }
        return (
            <div>
                <Row>
                    <Col>
                        <h4 style={{fontSize: '2.4rem'}}>Dispatches</h4>
                    </Col>
                </Row>
                <Row style={{marginBottom: '1vh'}}>
                    <Col md={2}>
                        <h3>Search Source Well:</h3>
                        <Input
                            type="text"
                            name="wellSearchSource"
                            value={this.state.wellSearchSource}
                            onChange={this.handleWellSearch}
                        />
                    </Col>
                    <Col md={2}>
                        <h3>Search Destination Well:</h3>
                        <Input
                            type="text"
                            name="wellSearchDest"
                            value={this.state.wellSearchDest}
                            onChange={this.handleWellSearch}
                        />
                    </Col>
                    <Col>
                        <h3>Filter by Type:</h3>
                        <Button type='button' color={this.allButtonTypeColor('typeFilters')} onClick={this.handleFilterBoxClick('typeFilters', 'all')}>All</Button>
                        {' '}
                        <ButtonGroup>
                            <Button type='button' color={this.buttonColor('typeFilters', 'transfer')} onClick={this.handleFilterBoxClick('typeFilters', 'transfer')}>Transfer</Button>
                            <Button type='button' color={this.buttonColor('typeFilters', 'delivery')} onClick={this.handleFilterBoxClick('typeFilters', 'delivery')}>Delivery</Button>
                            <Button type='button' color={this.buttonColor('typeFilters', 'pickup')} onClick={this.handleFilterBoxClick('typeFilters', 'pickup')}>Pickup</Button>
                        </ButtonGroup>
                    </Col>
                    <Col md={5}>
                        <h3>Filter by Status:</h3>
                        <Button type='button' color={this.allButtonTypeColor('statusFilters')} onClick={this.handleFilterBoxClick('statusFilters', 'all')}>All</Button>
                        {' '}
                        <ButtonGroup>
                            <Button type='button' color={this.buttonColor('statusFilters', 'submitted')} onClick={this.handleFilterBoxClick('statusFilters', 'submitted')}>Submitted</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'approved')} onClick={this.handleFilterBoxClick('statusFilters', 'approved')}>Approved</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'rejected')} onClick={this.handleFilterBoxClick('statusFilters', 'rejected')}>Rejected</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'confirmed')} onClick={this.handleFilterBoxClick('statusFilters', 'confirmed')}>Confirmed</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'denied')} onClick={this.handleFilterBoxClick('statusFilters', 'denied')}>Denied</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'completed')} onClick={this.handleFilterBoxClick('statusFilters', 'completed')}>Completed</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'cancelled')} onClick={this.handleFilterBoxClick('statusFilters', 'cancelled')}>Cancelled</Button>
                        </ButtonGroup>
                    
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DispatchListTable 
                            dispatchList={this.DispatchStore.dispatches.filter(this.filterDispatchList)}
                            showApprovalColumn={this.DispatchStore.dispatches.filter(this.filterDispatchList).map(this.mapShowApproval)}
                            onApprove={this.approveDispatch}
                            onReject={this.rejectDispatch}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    

}


// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/Dispatches/Dispatches.tsx